import TextField from "@mui/material/TextField"
import Autocomplete from "@mui/material/Autocomplete"
import { PostAdminContext } from "./Posts"
import { useContext } from "react"

const PostUserIdFilter = ({ maxWidth }) => {
	const postAdminContext = useContext(PostAdminContext)
	const handleUserIdFilter = postAdminContext.handleUserIdFilter
	const posts = postAdminContext.posts

	return (
		<Autocomplete
			disablePortal
			options={[...new Set(posts.map((post) => post.userId))].map((user) => ({
				label: user,
				id: user,
			}))}
			renderInput={(params) => <TextField {...params} label="משתמש" />}
			size="small"
			sx={{ width: "100%", pb: 1, maxWidth: maxWidth ?? "auto" }}
			onChange={(event, newValue) => {
				handleUserIdFilter(newValue)
			}}
			isOptionEqualToValue={(option, value) => option.id === value.id}
		/>
	)
}

export default PostUserIdFilter
